// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: assertions/assertion_types.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  AssertBgpPeerEstablished,
  AssertDeviceConnectedToCloud,
  AssertDeviceConnectedToFabric,
  AssertDeviceFanSpeedBelowThreshold,
  AssertDevicePsuUsageBelowThreshold,
  AssertDeviceResourceUsageBelowThreshold,
  AssertDeviceTemperatureBelowThreshold,
  AssertExpectedPortBreakoutExists,
  AssertManagementPortConfigSame,
  AssertMultisiteExpectedMtu,
  AssertMultisiteLatencyStable,
  AssertMultisiteLinkUp,
  AssertNxosDeviceExpectedFeatures,
  AssertPortChannelMemberUp,
  AssertPortConnectionSpeedMatch,
  AssertPortExpectedNeighbor,
  AssertPortLinkDown,
  AssertPortLinkUp,
  AssertPortNotConnectedToFabric,
  AssertPortNoUnknownVlanFound,
  AssertPortPluggablePidSame,
  AssertPortQsfpHealthy,
  AssertPortSpeedConsistent,
  AssertPortVlanStpStateConsistent,
  AssertStaticDefaultRouteExists,
  AssertSubInterfaceDown,
  AssertSubInterfaceUp,
  AssertVlanHasTraffic,
} from "../schema/schema";

export const protobufPackage = "assertions";

/** LatchState defines an enumeration of assertion latched/unlatched states. */
export enum LatchState {
  LATCH_STATE_UNSPECIFIED = 0,
  LATCHED = 1,
  UNLATCHED = 2,
  UNRECOGNIZED = -1,
}

export function latchStateFromJSON(object: any): LatchState {
  switch (object) {
    case 0:
    case "LATCH_STATE_UNSPECIFIED":
      return LatchState.LATCH_STATE_UNSPECIFIED;
    case 1:
    case "LATCHED":
      return LatchState.LATCHED;
    case 2:
    case "UNLATCHED":
      return LatchState.UNLATCHED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LatchState.UNRECOGNIZED;
  }
}

export function latchStateToJSON(object: LatchState): string {
  switch (object) {
    case LatchState.LATCH_STATE_UNSPECIFIED:
      return "LATCH_STATE_UNSPECIFIED";
    case LatchState.LATCHED:
      return "LATCHED";
    case LatchState.UNLATCHED:
      return "UNLATCHED";
    case LatchState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AssertTransitionStates {
  /** ASSERT_STATE_NO_OP - No transition */
  ASSERT_STATE_NO_OP = 0,
  /** ASSERT_STATE_UNSPECIFIED - From any other state to the unspecified state */
  ASSERT_STATE_UNSPECIFIED = 1,
  /** ASSERT_STATE_UNKNOWN - From any other state to the unknown state */
  ASSERT_STATE_UNKNOWN = 2,
  /** ASSERT_STATE_TRUE - From the unspecified or unknown state to the true state */
  ASSERT_STATE_TRUE = 3,
  /** ASSERT_STATE_FALSE - From any other state to the false state */
  ASSERT_STATE_FALSE = 4,
  /** ASSERT_STATE_CLEARED - From the false state to the true state */
  ASSERT_STATE_CLEARED = 5,
  /** CONFIG_ADDED - Reserved for the CONFIG_ADDED_TO_DB AssertType */
  CONFIG_ADDED = 6,
  /** SW_CONFIG_ADDED - Reserved for the SW_CONFIG_ADDED_TO_DB AssertType */
  SW_CONFIG_ADDED = 7,
  UNRECOGNIZED = -1,
}

export function assertTransitionStatesFromJSON(object: any): AssertTransitionStates {
  switch (object) {
    case 0:
    case "ASSERT_STATE_NO_OP":
      return AssertTransitionStates.ASSERT_STATE_NO_OP;
    case 1:
    case "ASSERT_STATE_UNSPECIFIED":
      return AssertTransitionStates.ASSERT_STATE_UNSPECIFIED;
    case 2:
    case "ASSERT_STATE_UNKNOWN":
      return AssertTransitionStates.ASSERT_STATE_UNKNOWN;
    case 3:
    case "ASSERT_STATE_TRUE":
      return AssertTransitionStates.ASSERT_STATE_TRUE;
    case 4:
    case "ASSERT_STATE_FALSE":
      return AssertTransitionStates.ASSERT_STATE_FALSE;
    case 5:
    case "ASSERT_STATE_CLEARED":
      return AssertTransitionStates.ASSERT_STATE_CLEARED;
    case 6:
    case "CONFIG_ADDED":
      return AssertTransitionStates.CONFIG_ADDED;
    case 7:
    case "SW_CONFIG_ADDED":
      return AssertTransitionStates.SW_CONFIG_ADDED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssertTransitionStates.UNRECOGNIZED;
  }
}

export function assertTransitionStatesToJSON(object: AssertTransitionStates): string {
  switch (object) {
    case AssertTransitionStates.ASSERT_STATE_NO_OP:
      return "ASSERT_STATE_NO_OP";
    case AssertTransitionStates.ASSERT_STATE_UNSPECIFIED:
      return "ASSERT_STATE_UNSPECIFIED";
    case AssertTransitionStates.ASSERT_STATE_UNKNOWN:
      return "ASSERT_STATE_UNKNOWN";
    case AssertTransitionStates.ASSERT_STATE_TRUE:
      return "ASSERT_STATE_TRUE";
    case AssertTransitionStates.ASSERT_STATE_FALSE:
      return "ASSERT_STATE_FALSE";
    case AssertTransitionStates.ASSERT_STATE_CLEARED:
      return "ASSERT_STATE_CLEARED";
    case AssertTransitionStates.CONFIG_ADDED:
      return "CONFIG_ADDED";
    case AssertTransitionStates.SW_CONFIG_ADDED:
      return "SW_CONFIG_ADDED";
    case AssertTransitionStates.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** AssertType defines an enumeration of types of assertions. */
export enum AssertType {
  ASSERT_TYPE_UNSPECIFIED = 0,
  CONFIG_ADDED_TO_DB = 1,
  SW_CONFIG_ADDED_TO_DB = 2,
  PORT_LINK_UP = 37,
  DEVICE_CONNECTED_TO_CLOUD = 39,
  PORT_EXPECTED_NEIGHBOR = 41,
  PORT_NOT_CONNECTED_TO_FABRIC = 43,
  DEVICE_CONNECTED_TO_FABRIC = 45,
  PORT_LINK_DOWN = 47,
  PORT_CONNECTION_SPEED_MATCH = 49,
  PORT_SPEED_CONSISTENT = 51,
  VLAN_HAS_TRAFFIC = 58,
  STATIC_DEFAULT_ROUTE_EXISTS = 77,
  MANAGEMENT_PORT_CONFIG_SAME = 83,
  DEVICE_RESOURCE_USAGE_BELOW_THRESHOLD = 110,
  BGP_PEER_ESTABLISHED = 118,
  EXPECTED_PORT_BREAKOUT_EXISTS = 132,
  SUB_INTERFACE_UP = 134,
  SUB_INTERFACE_DOWN = 135,
  PORT_CHANNEL_MEMBER_UP = 140,
  PORT_VLAN_STP_STATE_CONSISTENT = 144,
  PORT_PLUGGABLE_PID_SAME = 146,
  PORT_NO_UNKNOWN_VLAN_FOUND = 251,
  DEVICE_FAN_SPEED_BELOW_THRESHOLD = 271,
  DEVICE_TEMPERATURE_BELOW_THRESHOLD = 273,
  DEVICE_PSU_USAGE_BELOW_THRESHOLD = 278,
  MULTISITE_LINK_UP = 318,
  PORT_QSFP_HEALTHY = 323,
  MULTISITE_LATENCY_STABLE = 325,
  MULTISITE_EXPECTED_MTU = 332,
  NXOS_DEVICE_EXPECTED_FEATURES = 340,
  UNRECOGNIZED = -1,
}

export function assertTypeFromJSON(object: any): AssertType {
  switch (object) {
    case 0:
    case "ASSERT_TYPE_UNSPECIFIED":
      return AssertType.ASSERT_TYPE_UNSPECIFIED;
    case 1:
    case "CONFIG_ADDED_TO_DB":
      return AssertType.CONFIG_ADDED_TO_DB;
    case 2:
    case "SW_CONFIG_ADDED_TO_DB":
      return AssertType.SW_CONFIG_ADDED_TO_DB;
    case 37:
    case "PORT_LINK_UP":
      return AssertType.PORT_LINK_UP;
    case 39:
    case "DEVICE_CONNECTED_TO_CLOUD":
      return AssertType.DEVICE_CONNECTED_TO_CLOUD;
    case 41:
    case "PORT_EXPECTED_NEIGHBOR":
      return AssertType.PORT_EXPECTED_NEIGHBOR;
    case 43:
    case "PORT_NOT_CONNECTED_TO_FABRIC":
      return AssertType.PORT_NOT_CONNECTED_TO_FABRIC;
    case 45:
    case "DEVICE_CONNECTED_TO_FABRIC":
      return AssertType.DEVICE_CONNECTED_TO_FABRIC;
    case 47:
    case "PORT_LINK_DOWN":
      return AssertType.PORT_LINK_DOWN;
    case 49:
    case "PORT_CONNECTION_SPEED_MATCH":
      return AssertType.PORT_CONNECTION_SPEED_MATCH;
    case 51:
    case "PORT_SPEED_CONSISTENT":
      return AssertType.PORT_SPEED_CONSISTENT;
    case 58:
    case "VLAN_HAS_TRAFFIC":
      return AssertType.VLAN_HAS_TRAFFIC;
    case 77:
    case "STATIC_DEFAULT_ROUTE_EXISTS":
      return AssertType.STATIC_DEFAULT_ROUTE_EXISTS;
    case 83:
    case "MANAGEMENT_PORT_CONFIG_SAME":
      return AssertType.MANAGEMENT_PORT_CONFIG_SAME;
    case 110:
    case "DEVICE_RESOURCE_USAGE_BELOW_THRESHOLD":
      return AssertType.DEVICE_RESOURCE_USAGE_BELOW_THRESHOLD;
    case 118:
    case "BGP_PEER_ESTABLISHED":
      return AssertType.BGP_PEER_ESTABLISHED;
    case 132:
    case "EXPECTED_PORT_BREAKOUT_EXISTS":
      return AssertType.EXPECTED_PORT_BREAKOUT_EXISTS;
    case 134:
    case "SUB_INTERFACE_UP":
      return AssertType.SUB_INTERFACE_UP;
    case 135:
    case "SUB_INTERFACE_DOWN":
      return AssertType.SUB_INTERFACE_DOWN;
    case 140:
    case "PORT_CHANNEL_MEMBER_UP":
      return AssertType.PORT_CHANNEL_MEMBER_UP;
    case 144:
    case "PORT_VLAN_STP_STATE_CONSISTENT":
      return AssertType.PORT_VLAN_STP_STATE_CONSISTENT;
    case 146:
    case "PORT_PLUGGABLE_PID_SAME":
      return AssertType.PORT_PLUGGABLE_PID_SAME;
    case 251:
    case "PORT_NO_UNKNOWN_VLAN_FOUND":
      return AssertType.PORT_NO_UNKNOWN_VLAN_FOUND;
    case 271:
    case "DEVICE_FAN_SPEED_BELOW_THRESHOLD":
      return AssertType.DEVICE_FAN_SPEED_BELOW_THRESHOLD;
    case 273:
    case "DEVICE_TEMPERATURE_BELOW_THRESHOLD":
      return AssertType.DEVICE_TEMPERATURE_BELOW_THRESHOLD;
    case 278:
    case "DEVICE_PSU_USAGE_BELOW_THRESHOLD":
      return AssertType.DEVICE_PSU_USAGE_BELOW_THRESHOLD;
    case 318:
    case "MULTISITE_LINK_UP":
      return AssertType.MULTISITE_LINK_UP;
    case 323:
    case "PORT_QSFP_HEALTHY":
      return AssertType.PORT_QSFP_HEALTHY;
    case 325:
    case "MULTISITE_LATENCY_STABLE":
      return AssertType.MULTISITE_LATENCY_STABLE;
    case 332:
    case "MULTISITE_EXPECTED_MTU":
      return AssertType.MULTISITE_EXPECTED_MTU;
    case 340:
    case "NXOS_DEVICE_EXPECTED_FEATURES":
      return AssertType.NXOS_DEVICE_EXPECTED_FEATURES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssertType.UNRECOGNIZED;
  }
}

export function assertTypeToJSON(object: AssertType): string {
  switch (object) {
    case AssertType.ASSERT_TYPE_UNSPECIFIED:
      return "ASSERT_TYPE_UNSPECIFIED";
    case AssertType.CONFIG_ADDED_TO_DB:
      return "CONFIG_ADDED_TO_DB";
    case AssertType.SW_CONFIG_ADDED_TO_DB:
      return "SW_CONFIG_ADDED_TO_DB";
    case AssertType.PORT_LINK_UP:
      return "PORT_LINK_UP";
    case AssertType.DEVICE_CONNECTED_TO_CLOUD:
      return "DEVICE_CONNECTED_TO_CLOUD";
    case AssertType.PORT_EXPECTED_NEIGHBOR:
      return "PORT_EXPECTED_NEIGHBOR";
    case AssertType.PORT_NOT_CONNECTED_TO_FABRIC:
      return "PORT_NOT_CONNECTED_TO_FABRIC";
    case AssertType.DEVICE_CONNECTED_TO_FABRIC:
      return "DEVICE_CONNECTED_TO_FABRIC";
    case AssertType.PORT_LINK_DOWN:
      return "PORT_LINK_DOWN";
    case AssertType.PORT_CONNECTION_SPEED_MATCH:
      return "PORT_CONNECTION_SPEED_MATCH";
    case AssertType.PORT_SPEED_CONSISTENT:
      return "PORT_SPEED_CONSISTENT";
    case AssertType.VLAN_HAS_TRAFFIC:
      return "VLAN_HAS_TRAFFIC";
    case AssertType.STATIC_DEFAULT_ROUTE_EXISTS:
      return "STATIC_DEFAULT_ROUTE_EXISTS";
    case AssertType.MANAGEMENT_PORT_CONFIG_SAME:
      return "MANAGEMENT_PORT_CONFIG_SAME";
    case AssertType.DEVICE_RESOURCE_USAGE_BELOW_THRESHOLD:
      return "DEVICE_RESOURCE_USAGE_BELOW_THRESHOLD";
    case AssertType.BGP_PEER_ESTABLISHED:
      return "BGP_PEER_ESTABLISHED";
    case AssertType.EXPECTED_PORT_BREAKOUT_EXISTS:
      return "EXPECTED_PORT_BREAKOUT_EXISTS";
    case AssertType.SUB_INTERFACE_UP:
      return "SUB_INTERFACE_UP";
    case AssertType.SUB_INTERFACE_DOWN:
      return "SUB_INTERFACE_DOWN";
    case AssertType.PORT_CHANNEL_MEMBER_UP:
      return "PORT_CHANNEL_MEMBER_UP";
    case AssertType.PORT_VLAN_STP_STATE_CONSISTENT:
      return "PORT_VLAN_STP_STATE_CONSISTENT";
    case AssertType.PORT_PLUGGABLE_PID_SAME:
      return "PORT_PLUGGABLE_PID_SAME";
    case AssertType.PORT_NO_UNKNOWN_VLAN_FOUND:
      return "PORT_NO_UNKNOWN_VLAN_FOUND";
    case AssertType.DEVICE_FAN_SPEED_BELOW_THRESHOLD:
      return "DEVICE_FAN_SPEED_BELOW_THRESHOLD";
    case AssertType.DEVICE_TEMPERATURE_BELOW_THRESHOLD:
      return "DEVICE_TEMPERATURE_BELOW_THRESHOLD";
    case AssertType.DEVICE_PSU_USAGE_BELOW_THRESHOLD:
      return "DEVICE_PSU_USAGE_BELOW_THRESHOLD";
    case AssertType.MULTISITE_LINK_UP:
      return "MULTISITE_LINK_UP";
    case AssertType.PORT_QSFP_HEALTHY:
      return "PORT_QSFP_HEALTHY";
    case AssertType.MULTISITE_LATENCY_STABLE:
      return "MULTISITE_LATENCY_STABLE";
    case AssertType.MULTISITE_EXPECTED_MTU:
      return "MULTISITE_EXPECTED_MTU";
    case AssertType.NXOS_DEVICE_EXPECTED_FEATURES:
      return "NXOS_DEVICE_EXPECTED_FEATURES";
    case AssertType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * An Assertion is a statement used to test assumptions made by the system to ensure that the
 * system is functioning as intended. An assertion can evaluate to true (working as intended)
 * or false (error, exception, potential failure or unexpected behavior found). An assertion
 * can be latched or unlatched, which affects whether an assertion's condition is evaluated
 * or not. Generally, an assertion automatically becomes latched after 5 minutes.
 * You can manually unlatch a latched assertion.
 */
export interface Assertion {
  /** The type of the assertion. */
  assertType: AssertType;
  /** A human readable description of the assertion type */
  assertDescription: string;
  /** The latch/unlatch state of the assertion. */
  state: LatchState;
  portLinkUp: AssertPortLinkUp | undefined;
  deviceConnectedToCloud: AssertDeviceConnectedToCloud | undefined;
  portExpectedNeighbor: AssertPortExpectedNeighbor | undefined;
  portNotConnectedToFabric: AssertPortNotConnectedToFabric | undefined;
  deviceConnectedToFabric: AssertDeviceConnectedToFabric | undefined;
  portLinkDown: AssertPortLinkDown | undefined;
  portConnectionSpeedMatch: AssertPortConnectionSpeedMatch | undefined;
  portSpeedConsistent: AssertPortSpeedConsistent | undefined;
  vlanHasTraffic: AssertVlanHasTraffic | undefined;
  staticDefaultRouteExists: AssertStaticDefaultRouteExists | undefined;
  managementPortConfigSame: AssertManagementPortConfigSame | undefined;
  deviceResourceUsageBelowThreshold: AssertDeviceResourceUsageBelowThreshold | undefined;
  bgpPeerEstablished: AssertBgpPeerEstablished | undefined;
  expectedPortBreakoutExists: AssertExpectedPortBreakoutExists | undefined;
  subInterfaceUp: AssertSubInterfaceUp | undefined;
  subInterfaceDown: AssertSubInterfaceDown | undefined;
  portChannelMemberUp: AssertPortChannelMemberUp | undefined;
  portVlanStpStateConsistent: AssertPortVlanStpStateConsistent | undefined;
  portPluggablePidSame: AssertPortPluggablePidSame | undefined;
  portNoUnknownVlanFound: AssertPortNoUnknownVlanFound | undefined;
  deviceFanSpeedBelowThreshold: AssertDeviceFanSpeedBelowThreshold | undefined;
  deviceTemperatureBelowThreshold: AssertDeviceTemperatureBelowThreshold | undefined;
  devicePsuUsageBelowThreshold: AssertDevicePsuUsageBelowThreshold | undefined;
  multisiteLinkUp: AssertMultisiteLinkUp | undefined;
  portQsfpHealthy: AssertPortQsfpHealthy | undefined;
  multisiteLatencyStable: AssertMultisiteLatencyStable | undefined;
  multisiteExpectedMtu: AssertMultisiteExpectedMtu | undefined;
  nxosDeviceExpectedFeatures: AssertNxosDeviceExpectedFeatures | undefined;
}

function createBaseAssertion(): Assertion {
  return {
    assertType: 0,
    assertDescription: "",
    state: 0,
    portLinkUp: undefined,
    deviceConnectedToCloud: undefined,
    portExpectedNeighbor: undefined,
    portNotConnectedToFabric: undefined,
    deviceConnectedToFabric: undefined,
    portLinkDown: undefined,
    portConnectionSpeedMatch: undefined,
    portSpeedConsistent: undefined,
    vlanHasTraffic: undefined,
    staticDefaultRouteExists: undefined,
    managementPortConfigSame: undefined,
    deviceResourceUsageBelowThreshold: undefined,
    bgpPeerEstablished: undefined,
    expectedPortBreakoutExists: undefined,
    subInterfaceUp: undefined,
    subInterfaceDown: undefined,
    portChannelMemberUp: undefined,
    portVlanStpStateConsistent: undefined,
    portPluggablePidSame: undefined,
    portNoUnknownVlanFound: undefined,
    deviceFanSpeedBelowThreshold: undefined,
    deviceTemperatureBelowThreshold: undefined,
    devicePsuUsageBelowThreshold: undefined,
    multisiteLinkUp: undefined,
    portQsfpHealthy: undefined,
    multisiteLatencyStable: undefined,
    multisiteExpectedMtu: undefined,
    nxosDeviceExpectedFeatures: undefined,
  };
}

export const Assertion: MessageFns<Assertion> = {
  encode(message: Assertion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.assertType !== 0) {
      writer.uint32(8).int32(message.assertType);
    }
    if (message.assertDescription !== "") {
      writer.uint32(26).string(message.assertDescription);
    }
    if (message.state !== 0) {
      writer.uint32(16).int32(message.state);
    }
    if (message.portLinkUp !== undefined) {
      AssertPortLinkUp.encode(message.portLinkUp, writer.uint32(378).fork()).join();
    }
    if (message.deviceConnectedToCloud !== undefined) {
      AssertDeviceConnectedToCloud.encode(message.deviceConnectedToCloud, writer.uint32(394).fork()).join();
    }
    if (message.portExpectedNeighbor !== undefined) {
      AssertPortExpectedNeighbor.encode(message.portExpectedNeighbor, writer.uint32(410).fork()).join();
    }
    if (message.portNotConnectedToFabric !== undefined) {
      AssertPortNotConnectedToFabric.encode(message.portNotConnectedToFabric, writer.uint32(426).fork()).join();
    }
    if (message.deviceConnectedToFabric !== undefined) {
      AssertDeviceConnectedToFabric.encode(message.deviceConnectedToFabric, writer.uint32(442).fork()).join();
    }
    if (message.portLinkDown !== undefined) {
      AssertPortLinkDown.encode(message.portLinkDown, writer.uint32(458).fork()).join();
    }
    if (message.portConnectionSpeedMatch !== undefined) {
      AssertPortConnectionSpeedMatch.encode(message.portConnectionSpeedMatch, writer.uint32(474).fork()).join();
    }
    if (message.portSpeedConsistent !== undefined) {
      AssertPortSpeedConsistent.encode(message.portSpeedConsistent, writer.uint32(490).fork()).join();
    }
    if (message.vlanHasTraffic !== undefined) {
      AssertVlanHasTraffic.encode(message.vlanHasTraffic, writer.uint32(546).fork()).join();
    }
    if (message.staticDefaultRouteExists !== undefined) {
      AssertStaticDefaultRouteExists.encode(message.staticDefaultRouteExists, writer.uint32(698).fork()).join();
    }
    if (message.managementPortConfigSame !== undefined) {
      AssertManagementPortConfigSame.encode(message.managementPortConfigSame, writer.uint32(746).fork()).join();
    }
    if (message.deviceResourceUsageBelowThreshold !== undefined) {
      AssertDeviceResourceUsageBelowThreshold.encode(
        message.deviceResourceUsageBelowThreshold,
        writer.uint32(962).fork(),
      ).join();
    }
    if (message.bgpPeerEstablished !== undefined) {
      AssertBgpPeerEstablished.encode(message.bgpPeerEstablished, writer.uint32(1026).fork()).join();
    }
    if (message.expectedPortBreakoutExists !== undefined) {
      AssertExpectedPortBreakoutExists.encode(message.expectedPortBreakoutExists, writer.uint32(1138).fork()).join();
    }
    if (message.subInterfaceUp !== undefined) {
      AssertSubInterfaceUp.encode(message.subInterfaceUp, writer.uint32(1154).fork()).join();
    }
    if (message.subInterfaceDown !== undefined) {
      AssertSubInterfaceDown.encode(message.subInterfaceDown, writer.uint32(1162).fork()).join();
    }
    if (message.portChannelMemberUp !== undefined) {
      AssertPortChannelMemberUp.encode(message.portChannelMemberUp, writer.uint32(1202).fork()).join();
    }
    if (message.portVlanStpStateConsistent !== undefined) {
      AssertPortVlanStpStateConsistent.encode(message.portVlanStpStateConsistent, writer.uint32(1234).fork()).join();
    }
    if (message.portPluggablePidSame !== undefined) {
      AssertPortPluggablePidSame.encode(message.portPluggablePidSame, writer.uint32(1250).fork()).join();
    }
    if (message.portNoUnknownVlanFound !== undefined) {
      AssertPortNoUnknownVlanFound.encode(message.portNoUnknownVlanFound, writer.uint32(2090).fork()).join();
    }
    if (message.deviceFanSpeedBelowThreshold !== undefined) {
      AssertDeviceFanSpeedBelowThreshold.encode(message.deviceFanSpeedBelowThreshold, writer.uint32(2250).fork())
        .join();
    }
    if (message.deviceTemperatureBelowThreshold !== undefined) {
      AssertDeviceTemperatureBelowThreshold.encode(message.deviceTemperatureBelowThreshold, writer.uint32(2266).fork())
        .join();
    }
    if (message.devicePsuUsageBelowThreshold !== undefined) {
      AssertDevicePsuUsageBelowThreshold.encode(message.devicePsuUsageBelowThreshold, writer.uint32(2306).fork())
        .join();
    }
    if (message.multisiteLinkUp !== undefined) {
      AssertMultisiteLinkUp.encode(message.multisiteLinkUp, writer.uint32(2626).fork()).join();
    }
    if (message.portQsfpHealthy !== undefined) {
      AssertPortQsfpHealthy.encode(message.portQsfpHealthy, writer.uint32(2666).fork()).join();
    }
    if (message.multisiteLatencyStable !== undefined) {
      AssertMultisiteLatencyStable.encode(message.multisiteLatencyStable, writer.uint32(2682).fork()).join();
    }
    if (message.multisiteExpectedMtu !== undefined) {
      AssertMultisiteExpectedMtu.encode(message.multisiteExpectedMtu, writer.uint32(2738).fork()).join();
    }
    if (message.nxosDeviceExpectedFeatures !== undefined) {
      AssertNxosDeviceExpectedFeatures.encode(message.nxosDeviceExpectedFeatures, writer.uint32(2802).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Assertion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.assertType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.assertDescription = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.portLinkUp = AssertPortLinkUp.decode(reader, reader.uint32());
          continue;
        }
        case 49: {
          if (tag !== 394) {
            break;
          }

          message.deviceConnectedToCloud = AssertDeviceConnectedToCloud.decode(reader, reader.uint32());
          continue;
        }
        case 51: {
          if (tag !== 410) {
            break;
          }

          message.portExpectedNeighbor = AssertPortExpectedNeighbor.decode(reader, reader.uint32());
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.portNotConnectedToFabric = AssertPortNotConnectedToFabric.decode(reader, reader.uint32());
          continue;
        }
        case 55: {
          if (tag !== 442) {
            break;
          }

          message.deviceConnectedToFabric = AssertDeviceConnectedToFabric.decode(reader, reader.uint32());
          continue;
        }
        case 57: {
          if (tag !== 458) {
            break;
          }

          message.portLinkDown = AssertPortLinkDown.decode(reader, reader.uint32());
          continue;
        }
        case 59: {
          if (tag !== 474) {
            break;
          }

          message.portConnectionSpeedMatch = AssertPortConnectionSpeedMatch.decode(reader, reader.uint32());
          continue;
        }
        case 61: {
          if (tag !== 490) {
            break;
          }

          message.portSpeedConsistent = AssertPortSpeedConsistent.decode(reader, reader.uint32());
          continue;
        }
        case 68: {
          if (tag !== 546) {
            break;
          }

          message.vlanHasTraffic = AssertVlanHasTraffic.decode(reader, reader.uint32());
          continue;
        }
        case 87: {
          if (tag !== 698) {
            break;
          }

          message.staticDefaultRouteExists = AssertStaticDefaultRouteExists.decode(reader, reader.uint32());
          continue;
        }
        case 93: {
          if (tag !== 746) {
            break;
          }

          message.managementPortConfigSame = AssertManagementPortConfigSame.decode(reader, reader.uint32());
          continue;
        }
        case 120: {
          if (tag !== 962) {
            break;
          }

          message.deviceResourceUsageBelowThreshold = AssertDeviceResourceUsageBelowThreshold.decode(
            reader,
            reader.uint32(),
          );
          continue;
        }
        case 128: {
          if (tag !== 1026) {
            break;
          }

          message.bgpPeerEstablished = AssertBgpPeerEstablished.decode(reader, reader.uint32());
          continue;
        }
        case 142: {
          if (tag !== 1138) {
            break;
          }

          message.expectedPortBreakoutExists = AssertExpectedPortBreakoutExists.decode(reader, reader.uint32());
          continue;
        }
        case 144: {
          if (tag !== 1154) {
            break;
          }

          message.subInterfaceUp = AssertSubInterfaceUp.decode(reader, reader.uint32());
          continue;
        }
        case 145: {
          if (tag !== 1162) {
            break;
          }

          message.subInterfaceDown = AssertSubInterfaceDown.decode(reader, reader.uint32());
          continue;
        }
        case 150: {
          if (tag !== 1202) {
            break;
          }

          message.portChannelMemberUp = AssertPortChannelMemberUp.decode(reader, reader.uint32());
          continue;
        }
        case 154: {
          if (tag !== 1234) {
            break;
          }

          message.portVlanStpStateConsistent = AssertPortVlanStpStateConsistent.decode(reader, reader.uint32());
          continue;
        }
        case 156: {
          if (tag !== 1250) {
            break;
          }

          message.portPluggablePidSame = AssertPortPluggablePidSame.decode(reader, reader.uint32());
          continue;
        }
        case 261: {
          if (tag !== 2090) {
            break;
          }

          message.portNoUnknownVlanFound = AssertPortNoUnknownVlanFound.decode(reader, reader.uint32());
          continue;
        }
        case 281: {
          if (tag !== 2250) {
            break;
          }

          message.deviceFanSpeedBelowThreshold = AssertDeviceFanSpeedBelowThreshold.decode(reader, reader.uint32());
          continue;
        }
        case 283: {
          if (tag !== 2266) {
            break;
          }

          message.deviceTemperatureBelowThreshold = AssertDeviceTemperatureBelowThreshold.decode(
            reader,
            reader.uint32(),
          );
          continue;
        }
        case 288: {
          if (tag !== 2306) {
            break;
          }

          message.devicePsuUsageBelowThreshold = AssertDevicePsuUsageBelowThreshold.decode(reader, reader.uint32());
          continue;
        }
        case 328: {
          if (tag !== 2626) {
            break;
          }

          message.multisiteLinkUp = AssertMultisiteLinkUp.decode(reader, reader.uint32());
          continue;
        }
        case 333: {
          if (tag !== 2666) {
            break;
          }

          message.portQsfpHealthy = AssertPortQsfpHealthy.decode(reader, reader.uint32());
          continue;
        }
        case 335: {
          if (tag !== 2682) {
            break;
          }

          message.multisiteLatencyStable = AssertMultisiteLatencyStable.decode(reader, reader.uint32());
          continue;
        }
        case 342: {
          if (tag !== 2738) {
            break;
          }

          message.multisiteExpectedMtu = AssertMultisiteExpectedMtu.decode(reader, reader.uint32());
          continue;
        }
        case 350: {
          if (tag !== 2802) {
            break;
          }

          message.nxosDeviceExpectedFeatures = AssertNxosDeviceExpectedFeatures.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Assertion {
    return {
      assertType: isSet(object.assertType) ? assertTypeFromJSON(object.assertType) : 0,
      assertDescription: isSet(object.assertDescription) ? globalThis.String(object.assertDescription) : "",
      state: isSet(object.state) ? latchStateFromJSON(object.state) : 0,
      portLinkUp: isSet(object.portLinkUp) ? AssertPortLinkUp.fromJSON(object.portLinkUp) : undefined,
      deviceConnectedToCloud: isSet(object.deviceConnectedToCloud)
        ? AssertDeviceConnectedToCloud.fromJSON(object.deviceConnectedToCloud)
        : undefined,
      portExpectedNeighbor: isSet(object.portExpectedNeighbor)
        ? AssertPortExpectedNeighbor.fromJSON(object.portExpectedNeighbor)
        : undefined,
      portNotConnectedToFabric: isSet(object.portNotConnectedToFabric)
        ? AssertPortNotConnectedToFabric.fromJSON(object.portNotConnectedToFabric)
        : undefined,
      deviceConnectedToFabric: isSet(object.deviceConnectedToFabric)
        ? AssertDeviceConnectedToFabric.fromJSON(object.deviceConnectedToFabric)
        : undefined,
      portLinkDown: isSet(object.portLinkDown) ? AssertPortLinkDown.fromJSON(object.portLinkDown) : undefined,
      portConnectionSpeedMatch: isSet(object.portConnectionSpeedMatch)
        ? AssertPortConnectionSpeedMatch.fromJSON(object.portConnectionSpeedMatch)
        : undefined,
      portSpeedConsistent: isSet(object.portSpeedConsistent)
        ? AssertPortSpeedConsistent.fromJSON(object.portSpeedConsistent)
        : undefined,
      vlanHasTraffic: isSet(object.vlanHasTraffic) ? AssertVlanHasTraffic.fromJSON(object.vlanHasTraffic) : undefined,
      staticDefaultRouteExists: isSet(object.staticDefaultRouteExists)
        ? AssertStaticDefaultRouteExists.fromJSON(object.staticDefaultRouteExists)
        : undefined,
      managementPortConfigSame: isSet(object.managementPortConfigSame)
        ? AssertManagementPortConfigSame.fromJSON(object.managementPortConfigSame)
        : undefined,
      deviceResourceUsageBelowThreshold: isSet(object.deviceResourceUsageBelowThreshold)
        ? AssertDeviceResourceUsageBelowThreshold.fromJSON(object.deviceResourceUsageBelowThreshold)
        : undefined,
      bgpPeerEstablished: isSet(object.bgpPeerEstablished)
        ? AssertBgpPeerEstablished.fromJSON(object.bgpPeerEstablished)
        : undefined,
      expectedPortBreakoutExists: isSet(object.expectedPortBreakoutExists)
        ? AssertExpectedPortBreakoutExists.fromJSON(object.expectedPortBreakoutExists)
        : undefined,
      subInterfaceUp: isSet(object.subInterfaceUp) ? AssertSubInterfaceUp.fromJSON(object.subInterfaceUp) : undefined,
      subInterfaceDown: isSet(object.subInterfaceDown)
        ? AssertSubInterfaceDown.fromJSON(object.subInterfaceDown)
        : undefined,
      portChannelMemberUp: isSet(object.portChannelMemberUp)
        ? AssertPortChannelMemberUp.fromJSON(object.portChannelMemberUp)
        : undefined,
      portVlanStpStateConsistent: isSet(object.portVlanStpStateConsistent)
        ? AssertPortVlanStpStateConsistent.fromJSON(object.portVlanStpStateConsistent)
        : undefined,
      portPluggablePidSame: isSet(object.portPluggablePidSame)
        ? AssertPortPluggablePidSame.fromJSON(object.portPluggablePidSame)
        : undefined,
      portNoUnknownVlanFound: isSet(object.portNoUnknownVlanFound)
        ? AssertPortNoUnknownVlanFound.fromJSON(object.portNoUnknownVlanFound)
        : undefined,
      deviceFanSpeedBelowThreshold: isSet(object.deviceFanSpeedBelowThreshold)
        ? AssertDeviceFanSpeedBelowThreshold.fromJSON(object.deviceFanSpeedBelowThreshold)
        : undefined,
      deviceTemperatureBelowThreshold: isSet(object.deviceTemperatureBelowThreshold)
        ? AssertDeviceTemperatureBelowThreshold.fromJSON(object.deviceTemperatureBelowThreshold)
        : undefined,
      devicePsuUsageBelowThreshold: isSet(object.devicePsuUsageBelowThreshold)
        ? AssertDevicePsuUsageBelowThreshold.fromJSON(object.devicePsuUsageBelowThreshold)
        : undefined,
      multisiteLinkUp: isSet(object.multisiteLinkUp)
        ? AssertMultisiteLinkUp.fromJSON(object.multisiteLinkUp)
        : undefined,
      portQsfpHealthy: isSet(object.portQsfpHealthy)
        ? AssertPortQsfpHealthy.fromJSON(object.portQsfpHealthy)
        : undefined,
      multisiteLatencyStable: isSet(object.multisiteLatencyStable)
        ? AssertMultisiteLatencyStable.fromJSON(object.multisiteLatencyStable)
        : undefined,
      multisiteExpectedMtu: isSet(object.multisiteExpectedMtu)
        ? AssertMultisiteExpectedMtu.fromJSON(object.multisiteExpectedMtu)
        : undefined,
      nxosDeviceExpectedFeatures: isSet(object.nxosDeviceExpectedFeatures)
        ? AssertNxosDeviceExpectedFeatures.fromJSON(object.nxosDeviceExpectedFeatures)
        : undefined,
    };
  },

  toJSON(message: Assertion): unknown {
    const obj: any = {};
    if (message.assertType !== 0) {
      obj.assertType = assertTypeToJSON(message.assertType);
    }
    if (message.assertDescription !== "") {
      obj.assertDescription = message.assertDescription;
    }
    if (message.state !== 0) {
      obj.state = latchStateToJSON(message.state);
    }
    if (message.portLinkUp !== undefined) {
      obj.portLinkUp = AssertPortLinkUp.toJSON(message.portLinkUp);
    }
    if (message.deviceConnectedToCloud !== undefined) {
      obj.deviceConnectedToCloud = AssertDeviceConnectedToCloud.toJSON(message.deviceConnectedToCloud);
    }
    if (message.portExpectedNeighbor !== undefined) {
      obj.portExpectedNeighbor = AssertPortExpectedNeighbor.toJSON(message.portExpectedNeighbor);
    }
    if (message.portNotConnectedToFabric !== undefined) {
      obj.portNotConnectedToFabric = AssertPortNotConnectedToFabric.toJSON(message.portNotConnectedToFabric);
    }
    if (message.deviceConnectedToFabric !== undefined) {
      obj.deviceConnectedToFabric = AssertDeviceConnectedToFabric.toJSON(message.deviceConnectedToFabric);
    }
    if (message.portLinkDown !== undefined) {
      obj.portLinkDown = AssertPortLinkDown.toJSON(message.portLinkDown);
    }
    if (message.portConnectionSpeedMatch !== undefined) {
      obj.portConnectionSpeedMatch = AssertPortConnectionSpeedMatch.toJSON(message.portConnectionSpeedMatch);
    }
    if (message.portSpeedConsistent !== undefined) {
      obj.portSpeedConsistent = AssertPortSpeedConsistent.toJSON(message.portSpeedConsistent);
    }
    if (message.vlanHasTraffic !== undefined) {
      obj.vlanHasTraffic = AssertVlanHasTraffic.toJSON(message.vlanHasTraffic);
    }
    if (message.staticDefaultRouteExists !== undefined) {
      obj.staticDefaultRouteExists = AssertStaticDefaultRouteExists.toJSON(message.staticDefaultRouteExists);
    }
    if (message.managementPortConfigSame !== undefined) {
      obj.managementPortConfigSame = AssertManagementPortConfigSame.toJSON(message.managementPortConfigSame);
    }
    if (message.deviceResourceUsageBelowThreshold !== undefined) {
      obj.deviceResourceUsageBelowThreshold = AssertDeviceResourceUsageBelowThreshold.toJSON(
        message.deviceResourceUsageBelowThreshold,
      );
    }
    if (message.bgpPeerEstablished !== undefined) {
      obj.bgpPeerEstablished = AssertBgpPeerEstablished.toJSON(message.bgpPeerEstablished);
    }
    if (message.expectedPortBreakoutExists !== undefined) {
      obj.expectedPortBreakoutExists = AssertExpectedPortBreakoutExists.toJSON(message.expectedPortBreakoutExists);
    }
    if (message.subInterfaceUp !== undefined) {
      obj.subInterfaceUp = AssertSubInterfaceUp.toJSON(message.subInterfaceUp);
    }
    if (message.subInterfaceDown !== undefined) {
      obj.subInterfaceDown = AssertSubInterfaceDown.toJSON(message.subInterfaceDown);
    }
    if (message.portChannelMemberUp !== undefined) {
      obj.portChannelMemberUp = AssertPortChannelMemberUp.toJSON(message.portChannelMemberUp);
    }
    if (message.portVlanStpStateConsistent !== undefined) {
      obj.portVlanStpStateConsistent = AssertPortVlanStpStateConsistent.toJSON(message.portVlanStpStateConsistent);
    }
    if (message.portPluggablePidSame !== undefined) {
      obj.portPluggablePidSame = AssertPortPluggablePidSame.toJSON(message.portPluggablePidSame);
    }
    if (message.portNoUnknownVlanFound !== undefined) {
      obj.portNoUnknownVlanFound = AssertPortNoUnknownVlanFound.toJSON(message.portNoUnknownVlanFound);
    }
    if (message.deviceFanSpeedBelowThreshold !== undefined) {
      obj.deviceFanSpeedBelowThreshold = AssertDeviceFanSpeedBelowThreshold.toJSON(
        message.deviceFanSpeedBelowThreshold,
      );
    }
    if (message.deviceTemperatureBelowThreshold !== undefined) {
      obj.deviceTemperatureBelowThreshold = AssertDeviceTemperatureBelowThreshold.toJSON(
        message.deviceTemperatureBelowThreshold,
      );
    }
    if (message.devicePsuUsageBelowThreshold !== undefined) {
      obj.devicePsuUsageBelowThreshold = AssertDevicePsuUsageBelowThreshold.toJSON(
        message.devicePsuUsageBelowThreshold,
      );
    }
    if (message.multisiteLinkUp !== undefined) {
      obj.multisiteLinkUp = AssertMultisiteLinkUp.toJSON(message.multisiteLinkUp);
    }
    if (message.portQsfpHealthy !== undefined) {
      obj.portQsfpHealthy = AssertPortQsfpHealthy.toJSON(message.portQsfpHealthy);
    }
    if (message.multisiteLatencyStable !== undefined) {
      obj.multisiteLatencyStable = AssertMultisiteLatencyStable.toJSON(message.multisiteLatencyStable);
    }
    if (message.multisiteExpectedMtu !== undefined) {
      obj.multisiteExpectedMtu = AssertMultisiteExpectedMtu.toJSON(message.multisiteExpectedMtu);
    }
    if (message.nxosDeviceExpectedFeatures !== undefined) {
      obj.nxosDeviceExpectedFeatures = AssertNxosDeviceExpectedFeatures.toJSON(message.nxosDeviceExpectedFeatures);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Assertion>, I>>(base?: I): Assertion {
    return Assertion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Assertion>, I>>(object: I): Assertion {
    const message = createBaseAssertion();
    message.assertType = object.assertType ?? 0;
    message.assertDescription = object.assertDescription ?? "";
    message.state = object.state ?? 0;
    message.portLinkUp = (object.portLinkUp !== undefined && object.portLinkUp !== null)
      ? AssertPortLinkUp.fromPartial(object.portLinkUp)
      : undefined;
    message.deviceConnectedToCloud =
      (object.deviceConnectedToCloud !== undefined && object.deviceConnectedToCloud !== null)
        ? AssertDeviceConnectedToCloud.fromPartial(object.deviceConnectedToCloud)
        : undefined;
    message.portExpectedNeighbor = (object.portExpectedNeighbor !== undefined && object.portExpectedNeighbor !== null)
      ? AssertPortExpectedNeighbor.fromPartial(object.portExpectedNeighbor)
      : undefined;
    message.portNotConnectedToFabric =
      (object.portNotConnectedToFabric !== undefined && object.portNotConnectedToFabric !== null)
        ? AssertPortNotConnectedToFabric.fromPartial(object.portNotConnectedToFabric)
        : undefined;
    message.deviceConnectedToFabric =
      (object.deviceConnectedToFabric !== undefined && object.deviceConnectedToFabric !== null)
        ? AssertDeviceConnectedToFabric.fromPartial(object.deviceConnectedToFabric)
        : undefined;
    message.portLinkDown = (object.portLinkDown !== undefined && object.portLinkDown !== null)
      ? AssertPortLinkDown.fromPartial(object.portLinkDown)
      : undefined;
    message.portConnectionSpeedMatch =
      (object.portConnectionSpeedMatch !== undefined && object.portConnectionSpeedMatch !== null)
        ? AssertPortConnectionSpeedMatch.fromPartial(object.portConnectionSpeedMatch)
        : undefined;
    message.portSpeedConsistent = (object.portSpeedConsistent !== undefined && object.portSpeedConsistent !== null)
      ? AssertPortSpeedConsistent.fromPartial(object.portSpeedConsistent)
      : undefined;
    message.vlanHasTraffic = (object.vlanHasTraffic !== undefined && object.vlanHasTraffic !== null)
      ? AssertVlanHasTraffic.fromPartial(object.vlanHasTraffic)
      : undefined;
    message.staticDefaultRouteExists =
      (object.staticDefaultRouteExists !== undefined && object.staticDefaultRouteExists !== null)
        ? AssertStaticDefaultRouteExists.fromPartial(object.staticDefaultRouteExists)
        : undefined;
    message.managementPortConfigSame =
      (object.managementPortConfigSame !== undefined && object.managementPortConfigSame !== null)
        ? AssertManagementPortConfigSame.fromPartial(object.managementPortConfigSame)
        : undefined;
    message.deviceResourceUsageBelowThreshold =
      (object.deviceResourceUsageBelowThreshold !== undefined && object.deviceResourceUsageBelowThreshold !== null)
        ? AssertDeviceResourceUsageBelowThreshold.fromPartial(object.deviceResourceUsageBelowThreshold)
        : undefined;
    message.bgpPeerEstablished = (object.bgpPeerEstablished !== undefined && object.bgpPeerEstablished !== null)
      ? AssertBgpPeerEstablished.fromPartial(object.bgpPeerEstablished)
      : undefined;
    message.expectedPortBreakoutExists =
      (object.expectedPortBreakoutExists !== undefined && object.expectedPortBreakoutExists !== null)
        ? AssertExpectedPortBreakoutExists.fromPartial(object.expectedPortBreakoutExists)
        : undefined;
    message.subInterfaceUp = (object.subInterfaceUp !== undefined && object.subInterfaceUp !== null)
      ? AssertSubInterfaceUp.fromPartial(object.subInterfaceUp)
      : undefined;
    message.subInterfaceDown = (object.subInterfaceDown !== undefined && object.subInterfaceDown !== null)
      ? AssertSubInterfaceDown.fromPartial(object.subInterfaceDown)
      : undefined;
    message.portChannelMemberUp = (object.portChannelMemberUp !== undefined && object.portChannelMemberUp !== null)
      ? AssertPortChannelMemberUp.fromPartial(object.portChannelMemberUp)
      : undefined;
    message.portVlanStpStateConsistent =
      (object.portVlanStpStateConsistent !== undefined && object.portVlanStpStateConsistent !== null)
        ? AssertPortVlanStpStateConsistent.fromPartial(object.portVlanStpStateConsistent)
        : undefined;
    message.portPluggablePidSame = (object.portPluggablePidSame !== undefined && object.portPluggablePidSame !== null)
      ? AssertPortPluggablePidSame.fromPartial(object.portPluggablePidSame)
      : undefined;
    message.portNoUnknownVlanFound =
      (object.portNoUnknownVlanFound !== undefined && object.portNoUnknownVlanFound !== null)
        ? AssertPortNoUnknownVlanFound.fromPartial(object.portNoUnknownVlanFound)
        : undefined;
    message.deviceFanSpeedBelowThreshold =
      (object.deviceFanSpeedBelowThreshold !== undefined && object.deviceFanSpeedBelowThreshold !== null)
        ? AssertDeviceFanSpeedBelowThreshold.fromPartial(object.deviceFanSpeedBelowThreshold)
        : undefined;
    message.deviceTemperatureBelowThreshold =
      (object.deviceTemperatureBelowThreshold !== undefined && object.deviceTemperatureBelowThreshold !== null)
        ? AssertDeviceTemperatureBelowThreshold.fromPartial(object.deviceTemperatureBelowThreshold)
        : undefined;
    message.devicePsuUsageBelowThreshold =
      (object.devicePsuUsageBelowThreshold !== undefined && object.devicePsuUsageBelowThreshold !== null)
        ? AssertDevicePsuUsageBelowThreshold.fromPartial(object.devicePsuUsageBelowThreshold)
        : undefined;
    message.multisiteLinkUp = (object.multisiteLinkUp !== undefined && object.multisiteLinkUp !== null)
      ? AssertMultisiteLinkUp.fromPartial(object.multisiteLinkUp)
      : undefined;
    message.portQsfpHealthy = (object.portQsfpHealthy !== undefined && object.portQsfpHealthy !== null)
      ? AssertPortQsfpHealthy.fromPartial(object.portQsfpHealthy)
      : undefined;
    message.multisiteLatencyStable =
      (object.multisiteLatencyStable !== undefined && object.multisiteLatencyStable !== null)
        ? AssertMultisiteLatencyStable.fromPartial(object.multisiteLatencyStable)
        : undefined;
    message.multisiteExpectedMtu = (object.multisiteExpectedMtu !== undefined && object.multisiteExpectedMtu !== null)
      ? AssertMultisiteExpectedMtu.fromPartial(object.multisiteExpectedMtu)
      : undefined;
    message.nxosDeviceExpectedFeatures =
      (object.nxosDeviceExpectedFeatures !== undefined && object.nxosDeviceExpectedFeatures !== null)
        ? AssertNxosDeviceExpectedFeatures.fromPartial(object.nxosDeviceExpectedFeatures)
        : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
